import { render } from "./ImageContentComponent.vue?vue&type=template&id=3609fd5e&scoped=true"
import script from "./ImageContentComponent.vue?vue&type=script&lang=js"
export * from "./ImageContentComponent.vue?vue&type=script&lang=js"

import "./ImageContentComponent.vue?vue&type=style&index=0&id=3609fd5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3609fd5e"]])

export default __exports__